import PropTypes from 'prop-types';
import React from 'react';
import signatureIcon from '../../../../Assets/Images/svgs/signature.svg';

const DisplaySign = React.forwardRef(({ Rname = '', height = '50px', marginTop = '-30px' }, ref) => {
	if (Rname?.length > 11) {
		Rname = Rname.slice(0, 11) + '...';
	}

	return (
		<div
			ref={ref}
			style={{
				display: 'flex',
				alignItems: 'center',
				backgroundColor: '#e4f0a5',
				borderRadius: '10px',
				padding: '0px',
				width: 'fit-content',
				marginTop,
				marginLeft: '-155px',
				opacity: 0.8,
				maxWidth: '161px',
				height
			}}
		>
			<img
				src={signatureIcon}
				alt='signature-icon'
				style={{
					width: '30px',
					height: '30px',
					marginLeft: '4px'
				}}
			/>
			<div>
				<p>{Rname}</p>
				<p style={{ fontSize: '10px' }}>your sign will display here</p>
			</div>
		</div>
	);
});

DisplaySign.displayName = 'DisplaySign';

DisplaySign.propTypes = {
	Rname: PropTypes.any,
	height: PropTypes.any,
	marginTop: PropTypes.any
};

export default DisplaySign;
